const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Associate QC History Report",
            href: "/associate-qc-history",
            arrow: "",
        },
    ],

    

    table_headers: [
        {
            text:   'Date',
            value:  'date',
            report_value: 'date',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"

        },
        {
            text:   'Room',
            value:  'room',
            report_value: 'room',
            type:   '',
            show: true,
            order: 0,
            style: "width: 30%"

        },
        {
            text:   'Supervisor',
            value:  'supervisor',
            report_value: 'supervisor',
            type:   '',
            show: true,
            order: 0,
            style: "width: 15%"
        },
        {
            text:   'Passing %',
            value:  'passing_percentage',
            report_value: 'passing_percentage',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'Template Name',
            value:  'inspection_template_name',
            report_value: 'inspection_template_name',
            type:   '',
            show: true,
            order: 0,
            style: "width: 20%"
        },
    ],
}

export default Resources;